import Login                        from "./views/Authentication/Login";

import Attachment                   from "./views/Common/Attachment";
import Home                         from "./views/Common/Home";

import ItemRevision                 from "./views/Items/ItemRevision";
import ItemsOfType                  from "./views/Items/OfType";

import ProjectDetails               from "./views/Projects/ProjectDetails";
import AddressView                  from "./views/BusinessPartners/Address";
import BusinessPartnerDetails       from "./views/BusinessPartners/BusinessPartnerDetails";
import Contactperson                from "./views/BusinessPartners/Contactperson";
import LicenseDetails               from "./views/Licenses/LicenseDetails";

import AddressTypes                 from "./views/ItemSetup/AddressTypes";
import AddressType                  from "./views/ItemSetup/AddressType";
import Brands                       from "./views/ItemSetup/Brands";
import Brand                        from "./views/ItemSetup/Brand";
import Countries                    from "./views/ItemSetup/Countries";
import Country                      from "./views/ItemSetup/Country";
import Currencies                   from "./views/ItemSetup/Currencies";
import Currency                     from "./views/ItemSetup/Currency";
import DesignPhases                 from "./views/ItemSetup/DesignPhases";
import DesignPhase                  from "./views/ItemSetup/DesignPhase";
import IncoTerms                    from "./views/ItemSetup/IncoTerms";
import IncoTerm                     from "./views/ItemSetup/IncoTerm";
import ItemStatuses                 from "./views/ItemSetup/ItemStatuses";
import ItemStatus                   from "./views/ItemSetup/ItemStatus";
import ItemStatusTypes              from "./views/ItemSetup/ItemStatusTypes";
import ItemStatusType               from "./views/ItemSetup/ItemStatusType";
import ItemTypes                    from "./views/ItemSetup/ItemTypes";
import ItemType                     from "./views/ItemSetup/ItemType";
import PriceTypes                   from "./views/ItemSetup/PriceTypes";
import PriceType                    from "./views/ItemSetup/PriceType";
import ProductCategories            from "./views/ItemSetup/ProductCategories";
import ProductCategory              from "./views/ItemSetup/ProductCategory";
import Regions                      from "./views/ItemSetup/Regions";
import Region                       from "./views/ItemSetup/Region";
import RoyaltyTypes                 from "./views/ItemSetup/RoyaltyTypes";
import RoyaltyType                  from "./views/ItemSetup/RoyaltyType";
import UserDefinedFields            from "./views/ItemSetup/UserDefinedFields";
import UserDefinedField             from "./views/ItemSetup/UserDefinedField";
import UserDefinedFieldCategories   from "./views/ItemSetup/UserDefinedFieldCategories";
import UserDefinedFieldCategory     from "./views/ItemSetup/UserDefinedFieldCategory";

import SearchItemView               from "./views/Search/Item";
import SearchItemAdvancedView       from "./views/Search/ItemAdvanced";
import SearchProjectView            from "./views/Search/Project";
import SearchBusinessPartnerView    from "./views/Search/BusinessPartner";
import SearchLicenseView            from "./views/Search/License";
import SearchUserView               from "./views/Search/User";
import SearchWorkflowTaskView       from "./views/Search/WorkflowTask";

import User                         from "./views/UserManagement/User";

import TaskView                     from "./views/Workflow/Task";

var routes = [
    { layout: "/auth", path: "/login", component: Login },

    { layout: "/plm", path: "/common/home", component: Home },
    { layout: "/plm", path: "/common/attachment/:id", component: Attachment },

    { layout: "/plm", path: "/items/itemrevision/:id", component: ItemRevision },
    { layout: "/plm", path: "/items/oftype/:itemTypeId", component: ItemsOfType },
    { layout: "/plm", path: "/projects/details/:id", component: ProjectDetails },
    { layout: "/plm", path: "/address/:id", component: AddressView },
    { layout: "/plm", path: "/businesspartner/:id", component: BusinessPartnerDetails },
    { layout: "/plm", path: "/contactperson/:id", component: Contactperson },
    { layout: "/plm", path: "/licenses/:id", component: LicenseDetails },

    { layout: "/plm", path: "/itemsetup/addresstypes/", component: AddressTypes },
    { layout: "/plm", path: "/itemsetup/addresstype/:id", component: AddressType },
    { layout: "/plm", path: "/itemsetup/brands/", component: Brands },
    { layout: "/plm", path: "/itemsetup/brand/:id", component: Brand },
    { layout: "/plm", path: "/itemsetup/countries", component: Countries },
    { layout: "/plm", path: "/itemsetup/country/:id", component: Country },
    { layout: "/plm", path: "/itemsetup/currencies", component: Currencies },
    { layout: "/plm", path: "/itemsetup/currency/:id", component: Currency },
    { layout: "/plm", path: "/itemsetup/designphases", component: DesignPhases },
    { layout: "/plm", path: "/itemsetup/designphase/:id", component: DesignPhase },
    { layout: "/plm", path: "/itemsetup/incoterms", component: IncoTerms },
    { layout: "/plm", path: "/itemsetup/incoterm/:id", component: IncoTerm },
    { layout: "/plm", path: "/itemsetup/itemstatuses", component: ItemStatuses },
    { layout: "/plm", path: "/itemsetup/itemstatus/:id", component: ItemStatus },
    { layout: "/plm", path: "/itemsetup/itemstatustypes", component: ItemStatusTypes },
    { layout: "/plm", path: "/itemsetup/itemstatustype/:id", component: ItemStatusType },
    { layout: "/plm", path: "/itemsetup/pricetypes/", component: PriceTypes },
    { layout: "/plm", path: "/itemsetup/pricetype/:id", component: PriceType },
    { layout: "/plm", path: "/itemsetup/productcategories/", component: ProductCategories },
    { layout: "/plm", path: "/itemsetup/productcategory/:id", component: ProductCategory },
    { layout: "/plm", path: "/itemsetup/regions/", component: Regions },
    { layout: "/plm", path: "/itemsetup/region/:id", component: Region },
    { layout: "/plm", path: "/itemsetup/royaltytypes/", component: RoyaltyTypes },
    { layout: "/plm", path: "/itemsetup/royaltytype/:id", component: RoyaltyType },
    { layout: "/plm", path: "/itemsetup/userdefinedfields/", component: UserDefinedFields },
    { layout: "/plm", path: "/itemsetup/userdefinedfield/:id", component: UserDefinedField },
    { layout: "/plm", path: "/itemsetup/userdefinedfieldcategories/", component: UserDefinedFieldCategories },
    { layout: "/plm", path: "/itemsetup/userdefinedfieldcategory/:id", component: UserDefinedFieldCategory },
    { layout: "/plm", path: "/itemsetup/itemtypes/", component: ItemTypes },
    { layout: "/plm", path: "/itemsetup/itemtype/:id", component: ItemType },

    { layout: "/plm", path: "/search/item/", component: SearchItemView },
    { layout: "/plm", path: "/search/itemadvanced/", component: SearchItemAdvancedView },
    { layout: "/plm", path: "/search/project/", component: SearchProjectView },
    { layout: "/plm", path: "/search/license/", component: SearchLicenseView },
    { layout: "/plm", path: "/search/user/", component: SearchUserView },
    { layout: "/plm", path: "/search/workflowtask/", component: SearchWorkflowTaskView },
    { layout: "/plm", path: "/businesspartners/", component: SearchBusinessPartnerView },

    { layout: "/plm", path: "/usermanagement/user/:id", component: User },
    { layout: "/plm", path: "/usermanagement/myprofile", component: User },

    { layout: "/plm", path: "/workflow/task/:id", component: TaskView },
];
export default routes;
